import { useAppSelector } from '@/redux/hooks';
import { useSplitTreatments } from '@splitsoftware/splitio-react';

export const useStorefrontReturnsEnabled = (retailerId?: number) => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const appConfig = useAppSelector((state) => state.appConfig);

  const { treatments } = useSplitTreatments({
    names: ['brandclub_storefront_returns'],
    attributes: {
      email: userProfile?.email ?? '',
      appId: appConfig?.brandAppConfig?.appId ?? '',
      retailerId: retailerId ?? 0,
    },
  });

  return treatments['brandclub_storefront_returns']?.treatment === 'on';
};
